import React from 'react';
import PropTypes from 'prop-types';
import { KEY_SPACE } from 'core/theme/components/accessibility';
import { StyledCheckbox } from './styled';

class Checkbox extends React.PureComponent {
  static propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    checked: false,
    onChange: undefined,
  };

  // TODO: Controlled component state

  componentDidMount() {
    this._ref.addEventListener('keydown', this._onKeyDown);
  }

  componentWillUnmount() {
    this._ref.removeEventListener('keydown', this._onKeyDown);
  }

  _onKeyDown = (event) => {
    const { onChange } = this.props;
    if (event.which === KEY_SPACE) {
      onChange && onChange();
    }
  }

  render() {
    const {
      id,
      checked,
      disabled,
      onChange,
    } = this.props;

    return (
      <StyledCheckbox
        innerRef={c => this._ref = c}
        id={id}
        type='checkbox'
        tabIndex={disabled ? -1 : 0}
        defaultChecked={checked}
        onChange={onChange}
      />
    )
  }
}

export default Checkbox;


// WEBPACK FOOTER //
// ./src/elements/Checkbox/Checkbox.jsx